/**
 * Legacy setup wizard route — now redirects to the unified settings page
 * with onboarding mode enabled.
 *
 * Kept as a redirect to handle old bookmarks and external links gracefully.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$repoId/setup")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$repoId/settings",
      params: { repoId: params.repoId },
      search: { onboarding: true },
    });
  },
});
